import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
import { Button } from './Button';
import { CHECKOUT_URL, HERO_IMAGE } from '../data/offer';
import { trackCheckout } from '../utils/tracking';
const easeOut = [0.23, 1, 0.32, 1] as const;
const heroHighlights = ['6 Complete Volumes', '150 Ready-to-Coach Sessions', '5 Free Bonuses', 'Immediate Access'];
export function Hero() {
  return <section className="relative pt-6 sm:pt-10 pb-12 px-4 overflow-hidden bg-zinc-950 border-b border-zinc-800" data-id="element-130" data-mp="128yysajftrxl">
      <div className="max-w-5xl mx-auto flex flex-col items-center text-center" data-id="element-131" data-mp="xb5qnbykqnuo">
        {/* 1. Product name + 2. Title */}
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: easeOut
      }} className="w-full" data-id="element-132" data-mp="nc89iu3h9wlp">
          <div className="inline-block px-3 py-1 rounded-full border border-amber-400/60 bg-amber-400/10 text-amber-400 font-display font-extrabold text-[10px] sm:text-sm tracking-wide whitespace-nowrap mb-2 sm:mb-3" data-id="element-133" data-mp="382fedm0930dv">
            MMA COACH READY
          </div>
          <p className="font-display font-bold text-zinc-300 text-[11px] sm:text-sm tracking-wide uppercase mb-4 sm:mb-6" data-id="element-134" data-mp="3o73pmcpadw8l">
            The complete visual MMA coaching system
          </p>

          <h1 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-black uppercase leading-tight mb-2 sm:mb-4 text-white" data-id="element-135" data-mp="3e84mf9naissz">
            Solve months of MMA session planning in just{' '}
            <span className="text-red-500" data-id="element-136" data-mp="359jahxcbqc16">5 minutes</span>
          </h1>
        </motion.div>

        {/* 3. Mockup */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease: easeOut
      }} className="relative w-full max-w-[300px] sm:max-w-md md:max-w-xl px-2 sm:px-4 my-6 sm:my-8" data-id="element-137" data-mp="2qlogmdmky1mi">
          <img src={HERO_IMAGE} alt="MMA Coach Ready 6-in-1 box set: Foundations, Striking, Wrestling, BJJ & Grappling, Conditioning and Coaching System" className="relative z-10 block w-full h-auto object-contain mx-auto drop-shadow-2xl" loading="eager" decoding="async" data-id="element-138" data-mp="2lk8ra9ddd8yb" />
        </motion.div>

        {/* 4. Subtitle + 5. Payment button */}
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.2,
        ease: easeOut
      }} className="w-full" data-id="element-139" data-mp="db2ct9o7m5km">
          <p className="text-sm sm:text-base md:text-lg text-zinc-300 max-w-3xl mx-auto mb-3 sm:mb-4" data-id="element-140" data-mp="15zzvvf08w6ef">
            <span className="text-amber-400 font-semibold" data-id="element-141" data-mp="114kg2hiog0fd">150 Ready-to-Coach MMA Sessions</span> • 6
            Complete Volumes •{' '}
            <span className="text-amber-400 font-semibold" data-id="element-142" data-mp="3lt74sotvtnt7">5 Professional Bonus Guides</span>
          </p>
          <p className="text-sm sm:text-lg md:text-xl text-zinc-400 leading-snug max-w-2xl mx-auto mb-3 sm:mb-4" data-id="element-143" data-mp="3hqah4jphj1ie">
            A complete 6-in-1 visual coaching system created for MMA coaches who want structured,
            ready-to-use sessions without spending hours planning every week.
          </p>
          <p className="text-sm sm:text-lg md:text-xl text-white font-semibold leading-snug max-w-2xl mx-auto mb-5 sm:mb-7" data-id="element-144" data-mp="268y3xexznt1x">
            Open the system. Choose the skill. Follow the visual progression. Start coaching.
          </p>

          <div className="flex justify-center mb-5 sm:mb-6" data-id="element-145" data-mp="2g1wtp0581pn4">
            <Button href={CHECKOUT_URL} onLinkClick={trackCheckout} className="text-sm sm:text-lg md:text-xl py-3 sm:py-5 px-5 sm:px-10" data-id="element-146" data-mp="2kxudxhjlvg56">
              Get MMA Coach Ready Now
            </Button>
          </div>

          <p className="font-display font-extrabold text-amber-400 text-xs sm:text-sm tracking-wide uppercase mb-3 sm:mb-4" data-id="element-147" data-mp="umpqo3f6hozj">
            100% Visual • Ready to open &amp; coach
          </p>
          <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs sm:text-sm text-zinc-400" data-id="element-148" data-mp="4be13s18avuf">
            {heroHighlights.map(highlight => <div key={highlight} className="flex items-center gap-1.5" data-id="element-149" data-mp="3vh5owkrj9we2">
                <CheckCircle size={14} className="text-amber-400" aria-hidden="true" data-id="element-150" data-mp="e8iofv6t8xct" />
                <span data-id="element-151" data-mp="9a7c9dt1marf">{highlight}</span>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}